import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FormControl, Select, MenuItem } from "@mui/material";
import moment from "moment";

function LanguageSelect() {
  const [, { language, changeLanguage }] = useTranslation();

  useEffect(() => {
    moment.locale(language);
  }, [language]);

  return (
    <FormControl fullWidth>
      <Select
        value={language}
        onChange={(e) => changeLanguage(e.target.value)}
        style={{ height: 34 }}
      >
        <MenuItem value="en-US">English</MenuItem>
        <MenuItem value="es">Español</MenuItem>
      </Select>
    </FormControl>
  );
}

export default LanguageSelect;
